import { render } from "./Reports.vue?vue&type=template&id=318f6285"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Reports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "318f6285"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('318f6285', __exports__)) {
    api.reload('318f6285', __exports__)
  }
  
  module.hot.accept("./Reports.vue?vue&type=template&id=318f6285", () => {
    api.rerender('318f6285', render)
  })

}


export default __exports__